import { Init } from "@pdfking/reactivity/vue"
import { CreateSingleton, IsString, Partial, RecordMerge, Sleep } from "@pdfking/tfunc"
import { GENERIC_ERROR } from "@pdfking/translations/enum/errors"
import { get_translations } from "@pdfking/workflow/utils/make_translations"
import uuid from "@pdfking/workflow/utils/uuid"
import on from "../dom/on"

export default CreateSingleton(() => Init({
  data: { messages: {} },
  methods: {
    add(m, task?) {
      const counter = task ? task.counter : null
      const res: any = IsString(m)
        ? { content: m, counter }
        : RecordMerge(m, { counter })
      res.id = res.id || uuid()
      this.messages[res.id] = res

      const remove = Partial(this.remove, res.id)

      if (task) {
        task.then(remove)
      } else {
        Sleep(5000).then(remove)
      }
    },
    clear() {
      this.messages = {}
    },
    remove(id) {
      return delete this.messages[id]
    },
    send_error(error) {
      return get_translations("errors").then(lib =>
        this.add({
          class: "danger",
          content: lib[error] || lib[GENERIC_ERROR],
        })
      )
    },
  },
  init() {
    on("tracked_error", null, (_el, event: CustomEvent) =>
      this.send_error(event.detail)
    )
  },
}))
